import { createContext, useContext, useEffect, useState } from "react";
import { DEFAULT_CONTENT } from "./defaults";

const Ctx = createContext({ ...DEFAULT_CONTENT, settings: {} });

export const useContent = () => useContext(Ctx);

export const ContentProvider = ({ children }) => {
    const [content, setContent] = useState({
        ...DEFAULT_CONTENT,
        settings: {},
    });

    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/site-config`)
            .then((r) => (r.ok ? r.json() : null))
            .then((data) => {
                if (!data) return;
                setContent({
                    ...DEFAULT_CONTENT,
                    ...(data.content || {}),
                    settings: data.settings || {},
                });
            })
            .catch(() => {});
    }, []);

    return <Ctx.Provider value={content}>{children}</Ctx.Provider>;
};
